import axios from '../../axiosInstance';

const BillingbaseUrl='/operation';
const BillingbaseUrl2='/ob/billing';
const BillingbaseUrl3='/master';
const BillingbaseUrl4='/master/billing';
const BillingbaseUrl5='/Reports';

class BillingService {
    
    getnonAudit(sts){
        let Details ={importer_iec_no: '-1',consignmentNumber:'-1',status:sts}
        return axios.post(BillingbaseUrl+'/getJobNoBasedImpCMNonUploadCL',Details);
    }
    getAudit(sts){ 
        let Details ={importer_iec_no: '-1',consignmentNumber:'-1',status:sts}
        return axios.post(BillingbaseUrl+'/getJobNoBasedImpCMUploadCL',Details);
    }

    getJobNoBasedImpCMNonUploadCL(Details){
        return axios.post(BillingbaseUrl+'/getJobNoBasedImpCMNonUploadCL',Details);
    }

    getJobNoBasedImpCMUploadCL(Details){
        return axios.post(BillingbaseUrl+'/getJobNoBasedImpCMUploadCL',Details);
    }
    getJobBasedInvoice(Details){
        return axios.post(BillingbaseUrl2+'/getJobBasedInvoice',Details);
    }
    getJobBasedItem(Details){
        return axios.post(BillingbaseUrl2+'/getJobBasedItem',Details);
    }
    UploadBilling(Details){
        return axios.put(BillingbaseUrl2+'/UploadBilling',Details);
    }
    updateQuery(Details){
        return axios.put(BillingbaseUrl2+'/updateQuery',Details);
    }
    getConsignmentJobEntryAssign(Details){
        return axios.post(BillingbaseUrl2+'/getConsignmentJobEntryAssign',Details);
    }
    getConsignmentJobEntryAssignExport(Details){
        return axios.post(BillingbaseUrl2+'/getConsignmentJobEntryAssignExport',Details);
    }
// console bill
    getImporterDetails(){
        return axios.get(BillingbaseUrl3+'/getImporterDetails');
    }

    getbillName(billType){
        return axios.get(BillingbaseUrl2+'/getbillName?billType='+billType);
    }
    getBillPaymentType(){
        return axios.get(BillingbaseUrl2+'/getBillPaymentType');
    }
    getBillPaidBy(){
        return axios.get(BillingbaseUrl2+'/getBillPaidBy');
    }
    getVoucherType(){
        return axios.get(BillingbaseUrl2+'/getVoucherType');
    }
    getBillPaidTo(){
        return axios.get(BillingbaseUrl2+'/getBillPaidTo');
    }
    getPrintedType(){
        return axios.get(BillingbaseUrl2+'/getPrintedType');
    }
    insertBilling(details){
        return axios.post(BillingbaseUrl2+'/insertBilling',details);
    }
    updateBilling(details){
        return axios.put(BillingbaseUrl2+'/updateBilling',details);
    }
    getBilling(consignmentId,billType){
        return axios.get(BillingbaseUrl2+'/getBilling?consignmentId='+consignmentId+'&billType='+billType);
    }
    deleteBilling(billId){
        return axios.delete(BillingbaseUrl2+'/deleteBilling?billId='+billId);
    }
    opgetConsignmentJobEntryAssign(consignmentId){
        return axios.get(BillingbaseUrl+'/getConsignmentJobEntryAssign?consignmentId='+consignmentId);
    }
    // getJobDetailsAssign(consignmentId){
    //     return axios.get(BillingbaseUrl+'/getJobDetailsAssign?consignmentId='+consignmentId);
    // }

    //1stlvl
    getBillingQuotationDetails(consignmentId){
        return axios.get(BillingbaseUrl2+'/getBillingQuotationDetails?consignmentId='+consignmentId);
    }
    //2nd
    getBillingCustodian(consignmentId,billType){
        return axios.get(BillingbaseUrl2+'/getBillingCustodian?consignmentId='+consignmentId+'&billType='+billType);
    }
    getPaymentReqPurpose(details){
        return axios.post(BillingbaseUrl2+'/getPaymentReqPurpose',details);
    }
    getAllPayment(consignmentId,billType){
        return axios.get(BillingbaseUrl+'/getAllPayment?consignmentId='+consignmentId+'&billType='+billType);
    }
    getBillingCustom(consignmentId,billType){
        return axios.get(BillingbaseUrl2+'/getBillingCustom?consignmentId='+consignmentId+'&billType='+billType);
    }
    getBillingSummary(consignmentId){
        return axios.get(BillingbaseUrl2+'/getBillingSummary?consignmentId='+consignmentId);
    }
    update1stLevelVerification(details){
        return axios.put(BillingbaseUrl2+'/update1stLevelVerification',details);
    }
    deletedOverAllBilling(billId){
        return axios.delete(BillingbaseUrl2+'/deletedOverAllBilling?billId='+billId);
    }
    getJobDetailsOperationTypeBillPreview(consignmentNumber){
        return axios.get(BillingbaseUrl+'/getJobDetailsOperationTypeBillPreview?consignmentNumber='+consignmentNumber);
    }
    getJobDetailsBasedonOperationType(consignmentNumber){
        return axios.get(BillingbaseUrl+'/getJobDetailsBasedonOperationType?consignmentNumber='+consignmentNumber);
    }
    getRegionalOfficeDetails(){
        return axios.get(BillingbaseUrl3+'/getRegionalOfficeDetails');
    }
    updateJobBillPreview(details){
        return axios.post(BillingbaseUrl+'/updateJobBillPreview',details);
    }

    getQuotationBasedOnCustomerType(details){
        return axios.post(BillingbaseUrl4+'/getQuotationBasedOnCustomerType',details);
    }
    insertQuotationToBillingTariff(details){
        return axios.post(BillingbaseUrl+'/insertQuotationToBillingTariff',details);
    }
    getJobWeight(Flag,consignmentId){
        return axios.get(BillingbaseUrl+'/getJobWeight?Flag='+Flag+'&consignmentId='+consignmentId);
    }

    updateChargableWeight(details){
        return axios.put(BillingbaseUrl+'/updateChargableWeight',details);
    }
    getJobDetailsAssign(consignmentId){
        return axios.get(BillingbaseUrl+'/getJobDetailsAssign?consignmentId='+consignmentId);
    }
    getBillingGovtStaff(consignmentId,billType){
        return axios.get(BillingbaseUrl2+'/getBillingGovtStaff?consignmentId='+consignmentId+'&billType='+billType);
    }
    getBillingShippingLine(consignmentId,billType){
        return axios.get(BillingbaseUrl2+'/getBillingShippingLine?consignmentId='+consignmentId+'&billType='+billType);
    }
    getBillingAirlines(consignmentId,billType){
        return axios.get(BillingbaseUrl2+'/getBillingAirlines?consignmentId='+consignmentId+'&billType='+billType);
    }
    getBillingTransporter(consignmentId,billType){
        return axios.get(BillingbaseUrl2+'/getBillingTransporter?consignmentId='+consignmentId+'&billType='+billType);
    }
    getBillingForwarder(consignmentId,billType){
        return axios.get(BillingbaseUrl2+'/getBillingForwarder?consignmentId='+consignmentId+'&billType='+billType);
    }

    update2ndLevelVerification(details){
        return axios.put(BillingbaseUrl2+'/update2ndLevelVerification',details)
    }
    //billsubmission
    getEmployeeDetails(){
        return axios.get(BillingbaseUrl2+'/getEmployeeDetails');
    }
    updateBillSubmission(details){
        return axios.put(BillingbaseUrl+'/updateBillSubmission',details)
    }
    getBillSubmission(consignmentId){
        return axios.get(BillingbaseUrl+'/getBillSubmission?consignmentId='+consignmentId)
    }
    getDeliveryStateNameAll(){
        return axios.get(BillingbaseUrl3+'/getDeliveryStateName');
    }

    //trns
    getTransportDetails(){
        return axios.get(BillingbaseUrl2+'/getTransportDetails?transpor_id=-1');
    }
   
    addTransportDetails(data){
        return axios.post(BillingbaseUrl2+'/addTransportDetails',data);
    }
    updateTransportDetails(data){
        return axios.put(BillingbaseUrl2+'/updateTransportDetails',data);
    }
    deleteTransportDetails(transpor_id){
        return axios.delete(BillingbaseUrl2+'/deleteTransportDetails?transpor_id='+transpor_id);
    }

    //charge
    getTransport_charges(charges_id){
        return axios.get(BillingbaseUrl2+'/getTransport_charges?charges_id='+charges_id);
    }
    addTransport_charges(data){
        return axios.post(BillingbaseUrl2+'/addTransport_charges',data);
    }
    updateTransport_charges(charges_id,data){
        return axios.put(BillingbaseUrl2+'/updateTransport_charges?charges_id='+charges_id,data);
    }
    deleteTransport_charges(charges_id){
        return axios.delete(BillingbaseUrl2+'/deleteTransport_charges?charges_id='+charges_id);
    }
    TransistBillprintPDF_DAO(data){
        return axios.post(BillingbaseUrl5+'/TransistBillprintPDF_DAO',data);
    }
}

export default new BillingService();